export default __webpack_public_path__ + "static/media/contact.dcb4e760.svg";